import { daysOfTheWeekS, generalHelpers, typesOfPreaching } from '@monorepo/helpers';
import { FC } from 'react';
import { typePublicMinistryMonthlyService, typePublicMinistryService } from '@monorepo/models';
import { useGetIsDarkMode } from 'src/custom-hooks';

type propsType = {
    monthlyService: typePublicMinistryMonthlyService;
};

export const PublicMinistryByDate: FC<propsType> = ({ monthlyService }) => {
    const isDarkMode = useGetIsDarkMode();
    const servicesByDay = generalHelpers.GetPublicMinistryServicesByDay(monthlyService);

    return (
        <div className={'table-responsive'}>
            <table className={`table table-striped table-bordered ${isDarkMode ? 'table-dark' : 'table-light'} small`}>
                <thead>
                    <tr>
                        <th>Día</th>
                        <th>Hora</th>
                        {monthlyService.services.some(s => [2, 4].includes(s.typeOfRegularity)) &&
                            <th>Grupos</th>
                        }
                        <th>Predicación</th>
                        <th>Lugar</th>
                        <th>Capitán</th>
                        <th>Territorios</th>
                        <th>Observaciones</th>
                    </tr>
                </thead>
                <tbody>
                    {servicesByDay.map(sd =>
                        <Day key={sd.day}
                            day={sd.day}
                            monthlyService={monthlyService}
                            services={sd.services}
                        />
                    )}
                </tbody>
            </table>
        </div>
    )
}

type propsType1 = {
    day: number;
    monthlyService: typePublicMinistryMonthlyService;
    services: typePublicMinistryService[];
};

const Day: FC<propsType1> = ({ day, monthlyService, services }) => {
    const firstService = services.at(0);
    const weekday = new Date(monthlyService.year, monthlyService.month, day).getDay();

    return (
        <>
        <tr>
            <td rowSpan={services.length || 1} className={'text-nowrap'}>
                {daysOfTheWeekS[weekday]} {day}
            </td>
            <td>
                {firstService && `${firstService.hour.toString().padStart(2, '0')}:${firstService.minutes.toString().padStart(2, '0')}`}
            </td>
            {monthlyService.services.some(s => [2, 4].includes(s.typeOfRegularity)) &&
                <td>
                    {firstService && firstService.groups.join(', ')}
                </td>
            }
            <td>
                {firstService ? typesOfPreaching.find(tp => tp.type === firstService.typeOfPreaching)?.label : ''}
            </td>
            <td>
                {firstService && firstService.address1}
                {firstService && firstService.address2 &&
                    <><br />{firstService.address2}</>
                }
            </td>
            <td>
                {firstService?.isCircuitOverseer && '| VISITA |'} {firstService?.captain1 && `${firstService.captain1.name} ${firstService.captain1.lastName}`} {firstService?.captain2 && `| ${firstService.captain2.name} ${firstService.captain2.lastName}`}
            </td>
            <td>
                {firstService && firstService.territories.join(', ')}
            </td>
            <td>
                {firstService && firstService.observation}
            </td>
        </tr>
        {!!services.length && services.slice(1).map(s =>
            <tr key={s.id}>
                <td>
                    {s.hour.toString().padStart(2, '0')}:{s.minutes.toString().padStart(2, '0')}
                </td>
                {monthlyService.services.some(s => [2, 4].includes(s.typeOfRegularity)) &&
                    <td>
                        {s.groups.join(', ')}
                    </td>
                }
                <td>
                    {typesOfPreaching.find(tp => tp.type === s.typeOfPreaching)?.label}
                </td>
                <td>
                    {s.address1}
                    {s.address2 &&
                        <><br />{s.address2}</>
                    }
                </td>
                <td>
                    {firstService?.isCircuitOverseer && '| VISITA |'} {s.captain1 && `${s.captain1.name} ${s.captain1.lastName}`}
                </td>
                <td>
                    {s.territories.join(', ')}
                </td>
                <td>
                    {s.observation}
                </td>
            </tr>
        )}
        </>
    )
}
